/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { Row, Col, Form, Button } from "react-bootstrap";

import { useAuth, useDispatcher } from "../../components/AuthProvider"

import { MM } from "../../engine/model_manager";

import EditAccountPane from "./EditAccountPane";



function AddAccount(props) {
  const dispatch = useDispatcher();
  const navigate = useNavigate();
  let { type } = useParams();
  const results = useAuth();

  const model = results.currentModel.model;

  let acct = null;
  // ensure these endpoints match nav routes in Accounts.js
  switch (type) {
    case 'bankaccount':
      acct = MM.createBankAccount(model);
      break;
    case 'creditcard':
      acct = MM.createCreditCard(model);
      break;
    case 'lineofcredit':
      acct = MM.createLineOfCredit(model);
      break;
    case 'investment':
      acct = MM.createInvestment(model);
      break;
  }

  // Probably a cleaner way to ensure we create a valid account type
  React.useEffect(() => {
    if (acct === null) {
      navigate('/app/planner/accounts');
    }
  });


  function onSubmit(action) {
    dispatch(action);
    navigate(-1);
  }


  function onCancel() {
    navigate(-1);
  }


  return (
    <>
      <h3>Add Account {type}</h3>

      <EditAccountPane actionType="addAccount" modelAcct={acct} onSubmit={onSubmit} onCancel={onCancel} />
    </>
  );
}


export default AddAccount;

